// ============================================================
// FILE: JobDetail.js
// LOCATION: C:\gardenmarket\web\src\pages\buyer\JobDetail.js
// ============================================================
// PURPOSE:
//   Standalone full-page wrapper around JobDetailContent.js —
//   kept for direct links (e.g. bookmarked URLs, future email
//   notifications) even though BuyerDashboard.js now embeds the
//   same content in its master-detail pane for normal browsing.
//
// ROUTE: /buyer/job/:id
// ============================================================

import { useParams } from 'react-router-dom';
import JobDetailContent from './JobDetailContent';

export default function JobDetail() {
    const { id } = useParams();
    return <JobDetailContent jobId={id} embedded={false} />;
}
